import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=087e8022&scoped=true"
import script from "./ReportHeader.vue?vue&type=script&lang=ts"
export * from "./ReportHeader.vue?vue&type=script&lang=ts"
import style0 from "./ReportHeader.vue?vue&type=style&index=0&id=087e8022&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e8022",
  null
  
)

export default component.exports